import { Injectable, Inject } from "@angular/core";
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { IFormGoalsAndBenchmarks } from "../Models/Forms/IFormGoalsAndBenchmarks";
import { BaseService } from './BaseService';

@Injectable()
export class FormGoalsAndBenchmarksService extends BaseService {

  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormGoalsAndBenchmarks(id: number) {
    return this._http.get(this._baseUrl + "api/FormGoalsAndBenchmarks/" + id)
      .map((response: IFormGoalsAndBenchmarks) => response as IFormGoalsAndBenchmarks)
      .catch(this.errorHandler);
  }

  getGoalOrdinal(formInstanceId: number) {
    return this._http.get(this._baseUrl + "api/FormGoalsAndBenchmarks/GetGoalOrdinal" + formInstanceId)
      .map((response: IFormGoalsAndBenchmarks) => response as IFormGoalsAndBenchmarks)
      .catch(this.errorHandler);
  }

  insertUpdateFormGoalsAndBenchmarks(formGoalsAndBenchmarksDetails: IFormGoalsAndBenchmarks) {
    return this._http.post(this._baseUrl + 'api/FormGoalsAndBenchmarks', formGoalsAndBenchmarksDetails)
      .map((response: IFormGoalsAndBenchmarks) => response as IFormGoalsAndBenchmarks)
      .catch(this.errorHandler);
  }

  validateForm(id: number) {
    return this._http.get(this._baseUrl + "api/FormGoalsAndBenchmarks/ValidateForm" + id)
      .map((response: string[]) => response as string[])
      .catch(this.errorHandler)
  }

  deleteGoalsAndBenchmarks(id) {
    return this._http.delete(this._baseUrl + "api/FormGoalsAndBenchmarks" + id)
      .map((response: IFormGoalsAndBenchmarks) => response as IFormGoalsAndBenchmarks)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }

}


